import { ImageCarousel } from '@/common/components/ImageCarousel';
import Modal from '@/common/components/Modal'
import { InfoIcon } from 'lucide-react';
import ResumeItem from '@/common/components/ResumeItem';
import { MaintenanceForwardingCheckinEntryData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type';
import { Tooltip } from 'react-tooltip';
import { twMerge } from 'tailwind-merge';

interface MaintenanceWorkflowForwardingCheckinEntryInfoModalProps {
  checkinEntry: MaintenanceForwardingCheckinEntryData
}

export default function MaintenanceWorkflowForwardingCheckinEntryInfoModal({ checkinEntry }: MaintenanceWorkflowForwardingCheckinEntryInfoModalProps) {
  const shouldOpenModal = checkinEntry.observations || checkinEntry?.photos && checkinEntry?.photos?.length > 0
  
  return (
    <Modal
      Trigger={
        <>
          <InfoIcon 
            className={twMerge('text-valid max-w-4', !shouldOpenModal && 'text-gray-400')}
            data-tooltip-id='icon-tooltip'
          />

          <Tooltip id="icon-tooltip" content={shouldOpenModal ? "Ver informações adicionais" : "Sem informações adicionais"} place="top" />
        </>
      }
      triggerDisabled={!shouldOpenModal}
      className='min-w-[540px]'
      title="Informações do check-in"
      body={(
        <div className='flex gap-4'>
          {checkinEntry?.photos && checkinEntry?.photos?.length > 0 && (
            <ImageCarousel
              imageClassName='object-contain'
              className='size-52'
              files={checkinEntry?.photos?.map((file) => ({ id: file.id, file: file.url }))}
              showRemoveButton={false}
              showExpandButton
            />
          )}

          <ResumeItem
            label='Observações'
            value={checkinEntry.observations || '--'}
            valueClassName='text-sm'
          />
        </div>
      )}
    />
  )
}
